/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favoritcard.vue?vue&type=template&id=398eb491&scoped=true&"
import script from "./favoritcard.vue?vue&type=script&lang=js&"
export * from "./favoritcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398eb491",
  null
  
)

export default component.exports